"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthProvider = exports.AuthContext = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_router_1 = require("react-router");
var okta_react_1 = require("@okta/okta-react");
var cache_1 = require("../cache");
var AuthStatus_1 = require("./AuthStatus");
var config_1 = require("../config");
var FosAuthorizer_1 = require("./FosAuthorizer");
var routes_1 = require("./routes");
exports.AuthContext = (0, react_1.createContext)(null);
var AuthContextProvider = function (_a) {
    var children = _a.children;
    var ntConfig = (0, config_1.useNTConfig)();
    var oktaAuthState = (0, okta_react_1.useOktaAuth)().authState;
    var _b = (oktaAuthState !== null && oktaAuthState !== void 0 ? oktaAuthState : {}).isAuthenticated, isAuthenticated = _b === void 0 ? false : _b;
    var _c = (0, react_1.useState)({
        user: null,
        loading: true,
    }), state = _c[0], setState = _c[1];
    var _d = ntConfig.Amplify.Auth, clientId = _d.userPoolWebClientId, _e = _d.oauth, domain = _e.domain, redirectSignIn = _e.redirectSignIn, responseType = _e.responseType, PingSLO = ntConfig.PingSLO;
    // attempt to fetch the info of the user that was already logged in
    var fetchAndSaveUserInfo = (0, react_1.useCallback)(function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var userInfo, err_1;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAuthenticated) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, FosAuthorizer_1.FosAuthorizer.getUserInfo()];
                case 2:
                    userInfo = _a.sent();
                    setState({
                        user: userInfo,
                        loading: false,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.log('getUserInfo ERROR:', err_1);
                    setState({
                        user: null,
                        loading: false,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [isAuthenticated]);
    (0, react_1.useEffect)(function () {
        fetchAndSaveUserInfo();
    }, [fetchAndSaveUserInfo]);
    var logout = function () { return FosAuthorizer_1.FosAuthorizer.signOut(); };
    var loginUrl = "https://".concat(domain, "/oauth2/authorize?redirect_uri=").concat(redirectSignIn, "&response_type=").concat(responseType, "&client_id=").concat(clientId, "&identity_provider=PingIDP");
    var getCognitoUserSessionToken = (0, react_1.useCallback)(function () { return FosAuthorizer_1.FosAuthorizer.getAuthorizationToken(); }, []);
    var getClientId = function () { return cache_1.fosCache.getItem(cache_1.CLIENT_ID_CACHE_KEY); };
    var loading = state.loading, user = state.user;
    // eslint-disable-next-line no-nested-ternary
    var authState = loading
        ? AuthStatus_1.AuthStatus.LOADING
        : isAuthenticated
            ? AuthStatus_1.AuthStatus.LOGGED_IN
            : AuthStatus_1.AuthStatus.LOGGED_OUT;
    var values = (0, react_1.useMemo)(function () { return ({
        ntConfig: ntConfig,
        user: user,
        authState: authState,
        isAuthenticated: isAuthenticated,
        loginUrl: loginUrl,
        logout: logout,
        PingSLO: PingSLO,
        getCognitoUserSessionToken: getCognitoUserSessionToken,
        getClientId: getClientId,
    }); }, [
        getCognitoUserSessionToken,
        PingSLO,
        authState,
        loginUrl,
        ntConfig,
        user,
        isAuthenticated,
    ]);
    return react_1.default.createElement(exports.AuthContext.Provider, { value: values }, children);
};
var AuthProvider = function (_a) {
    var children = _a.children;
    var history = (0, react_router_1.useHistory)();
    var oktaAuth = FosAuthorizer_1.FosAuthorizer.oktaAuth;
    return (react_1.default.createElement(okta_react_1.Security, { oktaAuth: oktaAuth, restoreOriginalUri: function (_oktaAuth, originalUri) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                if (!originalUri) {
                    history.replace('/');
                }
                else {
                    history.replace(originalUri);
                }
                return [2 /*return*/];
            });
        }); }, onAuthRequired: function () {
            history.push(routes_1.routes.login);
        } },
        react_1.default.createElement(AuthContextProvider, null, children)));
};
exports.AuthProvider = AuthProvider;
